import { announcementsConstants } from "../constants/announcementsConstants";
import { announcementsService } from "../../services/API/announcementsService";
import { history } from "../store/configureStore";

export const announcementsActions = {
  getAnnouncementsData,
  getAnnouncementsList,
  deleteAnnouncements,
  getAnnouncementsDetails,
  getSiteList
};

function getAnnouncementsData() {
  return dispatch => {
    dispatch(request());
    announcementsService.getAnnouncementsList().then(
      announcements => {
        dispatch(success(announcements));
      },
      error => {
        dispatch(failure("getAnnouncementsData error: " + error.toString()));
      }
    );
  };

  function request(announcements) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_REQUEST, announcements };
  }
  function success(announcements) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_SUCCESS, announcements };
  }
  function failure(error) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_FAILURE, error };
  }
}

export const addAnnouncements = postData => {
  return dispatch => {
    dispatch(request());
    announcementsService.addAnnouncements(postData).then(
      announcements => {
        dispatch(success(announcements));
        history.push("/announcements");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(announcements) {
    return { type: announcementsConstants.ADD_ANNOUNCEMENTS_REQUEST, announcements };
  }
  function success(announcements) {
    return { type: announcementsConstants.ADD_ANNOUNCEMENTS_SUCCESS, announcements };
  }
  function failure(error) {
    return { type: announcementsConstants.ADD_ANNOUNCEMENTS_FAILURE, error };
  }
};

export const getAnnouncementsList = formData => {
  return dispatch => {
    dispatch(request());
    announcementsService.getAnnouncementsList(formData).then(
      announcements => {
        dispatch(success(announcements));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(announcements) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_REQUEST, announcements };
  }
  function success(announcements) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_SUCCESS, announcements };
  }
  function failure(error) {
    return { type: announcementsConstants.FETCH_ANNOUNCEMENTS_FAILURE, error };
  }
};

export const deleteAnnouncements = announcementsIdASParams => {
  return dispatch => {
    dispatch(request());
    announcementsService.deleteAnnouncements(announcementsIdASParams).then(
      announcements => {
        dispatch(success(announcements));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(announcements) {
    return { type: announcementsConstants.DELETE_ANNOUNCEMENTS_REQUEST, announcements };
  }
  function success(announcements) {
    return { type: announcementsConstants.DELETE_ANNOUNCEMENTS_SUCCESS, announcements };
  }
  function failure(error) {
    return { type: announcementsConstants.DELETE_ANNOUNCEMENTS_FAILURE, error };
  }
};

export const getAnnouncementsDetails = announcementsIdParams => {
  return dispatch => {
    dispatch(request());
    announcementsService.getAnnouncementsDetails(announcementsIdParams).then(
      announcementsDetails => {
        dispatch(success(announcementsDetails));
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(announcementsDetails) {
    return { type: announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_REQUEST, announcementsDetails };
  }
  function success(announcementsDetails) {
    return { type: announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_SUCCESS, announcementsDetails };
  }
  function failure(error) {
    return { type: announcementsConstants.GET_ANNOUNCEMENTS_DETAILS_FAILURE, error };
  }
};

export const updateAnnouncements = postData => {
  return dispatch => {
    dispatch(request());
    announcementsService.updateAnnouncements(postData).then(
      updatedAnnouncements => {
        dispatch(success(updatedAnnouncements));
        history.push("/announcements");
      },
      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(updatedAnnouncements) {
    return { type: announcementsConstants.UPDATE_ANNOUNCEMENTS_REQUEST, updatedAnnouncements };
  }
  function success(updatedAnnouncements) {
    return { type: announcementsConstants.UPDATE_ANNOUNCEMENTS_SUCCESS, updatedAnnouncements };
  }
  function failure(error) {
    return { type: announcementsConstants.UPDATE_ANNOUNCEMENTS_FAILURE, error };
  }
};

export const getSiteList = (page) => {
  return dispatch => {
    dispatch(request());
    announcementsService.get_SiteList(page).then(
      sitelist => {
        dispatch(success(sitelist));
      },

      error => {
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(sitelist) {
    return { type: announcementsConstants.FETCH_SITELIST_REQUEST, sitelist };
  }
  function success(sitelist) {
    return { type: announcementsConstants.FETCH_SITELIST_SUCCESS, sitelist };
  }
  function failure(error) {
    return { type: announcementsConstants.FETCH_SITELIST_FAILURE, error };
  }
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/announcementsActions.js